import { FieldPattern } from '..';

import { COLLEGE } from '../../../../constants/FieldTypeConstants';
import { FormFieldsType } from '../../../../types/FieldModelTypes';

import DependentField from '../DependentField';

class InstituteFormField extends DependentField {
  readonly type: string = COLLEGE;
  supportingField: string;
  mobilePlaceholder: string;

  constructor(instituteFieldData: FormFieldsType, initialValue: any) {
    super(instituteFieldData, initialValue);
    this.supportingField = instituteFieldData.supporting_field ?? '';
    this.mobilePlaceholder = instituteFieldData.mobile_placeholder ?? '';
  }

  match<T>(p: FieldPattern<T>): T {
    return p.InstituteField(this);
  }
}

export default InstituteFormField;
